import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setAdvisoryApproval, setAdvisoryFailureApproval } from '../state/action/advisoryAction';
import { GET_ADVISORY_APPROVAL } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getAdvisoryApprovalData() {
  let status = 0;
  try {
    const res = yield fetch(`${BASE_URL}/advisory/approval`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setAdvisoryApproval({ response }));
  } catch (error) {
    yield put(setAdvisoryFailureApproval());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* advisoryApprovalWatcher() {
  yield takeLatest(GET_ADVISORY_APPROVAL, getAdvisoryApprovalData);
}

function* advisoryApprovalListSagas() {
  yield all([
    call(advisoryApprovalWatcher),
  ]);
}

export default advisoryApprovalListSagas;
